import { render, staticRenderFns } from "./AutomatedInvestmentFundingV2.vue?vue&type=template&id=2360be42&scoped=true"
import script from "./AutomatedInvestmentFundingV2.vue?vue&type=script&lang=ts"
export * from "./AutomatedInvestmentFundingV2.vue?vue&type=script&lang=ts"
import style0 from "./AutomatedInvestmentFundingV2.vue?vue&type=style&index=0&id=2360be42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360be42",
  null
  
)

export default component.exports